import Box from "@mui/material/Box";
import React from "react";
import { BingoResolution } from "./BingoResolution";
import BingoSquare from "./BingoSquare";

interface BingoBoardProps {
  onBingoSquareClick: (resolutionId: string) => void;
  resolutions: BingoResolution[];
}

export default function BingoBoard({
  onBingoSquareClick,
  resolutions,
}: BingoBoardProps) {
  return (
    <Box display="grid" gridTemplateColumns="repeat(5, 1fr)" gap={0.5}>
      {resolutions.map((resolution) => (
        <BingoSquare
          onClick={() => onBingoSquareClick(resolution.id)}
          key={resolution.id}
          bingoResolution={resolution}
        />
      ))}
    </Box>
  );
}
